var Assam = "アッサム";
var Bihar = "ビハール";
var Chandigarh = "チャンディーガル";
var Chhattisgarh = "チャッティースガル";
var Delhi = "デリー";
var Goa = "ゴア";
var Gujarat = "グジャラート";
var Haryana = "ハリヤナ";
var Jharkhand = "ジャールカンド";
var Karnataka = "カルナータカ";
var Kerala = "ケーララ";
var Lakshwadeep = "ラクシュワディープ";
var Maharashtra = "マハーラーシュトラ";
var Manipur = "マニプール";
var Meghalaya = "メガラヤ";
var Mizoram = "ミゾラム";
var Nagaland = "ナガランド";
var Orrisa = "オリッサ";
var Puducherry = "ポンディシェリ";
var Punjab = "パンジャーブ";
var Rajasthan = "ラージャスターン";
var Sikkim = "シッキム";
var Telangana = "テランガーナ";
var Tripura = "トリプラ";
var Uttrakhand = "ウッタラーカンド";
var INStates = {
	"Andaman and Nicobar Islands": "アンダマン・ニコバル諸島",
	"Andhra Pradesh": "アーンドラ・プラデシュ",
	"Arunachal Pradesh": "アルナーチャル・プラデーシュ",
	Assam: Assam,
	Bihar: Bihar,
	Chandigarh: Chandigarh,
	Chhattisgarh: Chhattisgarh,
	"Dadra & Nagar Haveli": "ダドラ・ナガル・ハベリ",
	"Daman & Diu": "ダマン・ディウ",
	Delhi: Delhi,
	Goa: Goa,
	Gujarat: Gujarat,
	Haryana: Haryana,
	"Himachal Pradesh": "ヒマーチャル・プラデーシュ",
	"Jammu and Kashmir": "ジャンムー・カシミール",
	Jharkhand: Jharkhand,
	Karnataka: Karnataka,
	Kerala: Kerala,
	Lakshwadeep: Lakshwadeep,
	"Madhya Pradesh": "マディヤ・プラデーシュ",
	Maharashtra: Maharashtra,
	Manipur: Manipur,
	Meghalaya: Meghalaya,
	Mizoram: Mizoram,
	Nagaland: Nagaland,
	Orrisa: Orrisa,
	Puducherry: Puducherry,
	Punjab: Punjab,
	Rajasthan: Rajasthan,
	Sikkim: Sikkim,
	"Tamil Nadu": "タミルナードゥ",
	Telangana: Telangana,
	Tripura: Tripura,
	"Uttar Pradesh": "ウッタルプラデーシュ",
	Uttrakhand: Uttrakhand,
	"West Bengal": "西ベンガル"
};

export { Assam, Bihar, Chandigarh, Chhattisgarh, Delhi, Goa, Gujarat, Haryana, Jharkhand, Karnataka, Kerala, Lakshwadeep, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Orrisa, Puducherry, Punjab, Rajasthan, Sikkim, Telangana, Tripura, Uttrakhand, INStates as default };
